import { useTranslation } from "react-i18next";
import { Label, Input } from "@tellescope/design-system";
import { StringSelect } from "@tellescope/ui";
import type { HeadingBlock } from "../../../../../shared/schema";
import { LayoutSection } from "../shared/LayoutSection";
import { VisibilitySection } from "../shared/VisibilitySection";
import { StyleSection } from "../shared/StyleSection";
import type { BlockTypeEditorProps } from "../types";

type HeadingBlockEditorProps = BlockTypeEditorProps<HeadingBlock>;

export function HeadingBlockEditor({
  block,
  updateProps,
  updateLayout,
  updateVisibility,
  updateStyle,
  layoutOpen,
  setLayoutOpen,
  visibilityOpen,
  setVisibilityOpen,
  styleOpen,
  setStyleOpen,
}: HeadingBlockEditorProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>{t("Text")}</Label>
        <Input
          value={block.props.text}
          onChange={(e) => updateProps({ text: e.target.value })}
          placeholder={t("Enter heading text...")}
        />
      </div>
      <StringSelect
        label={t("Level")}
        value={block.props.level}
        onValueChange={(value) => updateProps({ level: value })}
        options={[
          { value: "h1", label: t("H1 - Page Title") },
          { value: "h2", label: t("H2 - Section") },
          { value: "h3", label: t("H3 - Subsection") },
          { value: "h4", label: t("H4 - Small") },
        ]}
      />
      <StyleSection style={block.style} onChange={updateStyle} open={styleOpen} onOpenChange={setStyleOpen} />
      <LayoutSection layout={block.layout} onChange={updateLayout} open={layoutOpen} onOpenChange={setLayoutOpen} />
      <VisibilitySection
        visibility={block.visibility}
        onChange={updateVisibility}
        open={visibilityOpen}
        onOpenChange={setVisibilityOpen}
      />
    </div>
  );
}
